











import Vue from "vue";
// import HelloWorld from './components/HelloWorld.vue';
// import VuetifyColors from "vuetify/lib/util/colors";
/* eslint-disable */
// @ts-ignore
import { generateColors } from "./utils/customColors";
/* eslint-enable */
import Navbar from "./components/shared/Navbar.vue";
// import MusicFooter from "./components/shared/MusicFooter.vue";

export default Vue.extend({
  name: "App",

  components: {
    // HelloWorld,
    Navbar
    // MusicFooter,
  },

  data: () => ({
    //
  }),
  computed: {
    cssProps() {
      const generatedColors = generateColors(this.$vuetify.theme.currentTheme);
      return generatedColors;
    }
  },

  watch: {
    $route(to) {
      document.title = `Banky Studio - ${to.meta.title ? to.meta.title : ""}`;
      const link = document.querySelector("[rel='icon']");
      if (link) {
        // link.setAttribute("href", "img/icons/nightprofile.jpg.webp");
        link.setAttribute("href", "img/icons/nightprofile.jpg");
        console.log(link);
      }
    }
  },
  mounted() {
    // console.log({
    //   breakpoint: this.$vuetify.breakpoint,
    //   sm: this.$vuetify.breakpoint.smOnly,
    //   xs: this.$vuetify.breakpoint.xsOnly,
    //   md: this.$vuetify.breakpoint.mdOnly,
    //   lg: this.$vuetify.breakpoint.lgOnly
    // });
    // console.log({ colors: this.$vuetify.theme });
  },
  beforeCreate() {
    this.$vuetify.theme.dark = true;
  }
});
